// extracted by mini-css-extract-plugin
module.exports = {"section_1":"style_section_1__C9Q3I","section_1_title":"style_section_1_title__29DoB","speakers_text":"style_speakers_text__N1M1_","speakers_list":"style_speakers_list__1gfe7"};